exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-grid[data-v-63ea85e6]{display:grid;grid-template-columns:repeat(auto-fit,minmax(300px,1fr));gap:20px;margin-top:20px}.info-field[data-v-63ea85e6]{display:flex;flex-direction:column}.table td[data-v-63ea85e6]{padding:4px!important;vertical-align:middle}.table-input[data-v-63ea85e6]{width:100%;height:30px;padding:2px 6px;box-sizing:border-box;border:1px solid #ccc;border-radius:4px;font-size:13px}.info-input[data-v-63ea85e6]{padding:8px;border:1px solid #ccc;border-radius:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-63ea85e6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ims/BenificialOwnership.vue
// module id = 118
// module chunks = 0